import { useQuery } from '@tanstack/react-query';
import { default as comerOriginService } from "../services/comerOrigin";

export const useComerOrigin = (gas: boolean = false) => {

  return useQuery({
    queryKey: ['comers', gas],
    queryFn: () => comerOriginService.fetchLeadComers(gas),
    staleTime: 1000 * 60 * 30
  })
  
}